import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Company from './Company';
import Features from './Features';
import Intro from './Intro';
import ContactUs from './Contactus';
import Login from './Login';
import LandingHeader from 'components/PageHeader/LandingHeader';
import './style.css';
var sectionMapper = {
    company: 0,
    features: 1,
};
var Landing = function () {
    var _a = useState(false), isModalVisible = _a[0], setIsModalVisible = _a[1];
    var _b = useState({ section: '', tick: 0 }), scrollRequest = _b[0], setScrollRequest = _b[1];
    var refs = useRef([]);
    var setPageSection = function (section) {
        setScrollRequest(function (current) { return ({ section: section, tick: current.tick + 1 }); });
    };
    useEffect(function () {
        var _a;
        var index = sectionMapper[scrollRequest.section];
        if (index === undefined)
            return;
        (_a = refs.current[index]) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, [scrollRequest]);
    return (_jsxs("div", { className: "lnd", children: [_jsx(LandingHeader, { setPageSection: setPageSection, showLoginModal: setIsModalVisible }), _jsx(Login, { isModalVisible: isModalVisible, showLoginModal: setIsModalVisible }), _jsx(Intro, {}), _jsx("div", { ref: function (element) { refs.current[sectionMapper.company] = element; }, children: _jsx(Company, {}) }), _jsx("div", { ref: function (element) { refs.current[sectionMapper.features] = element; }, children: _jsx(Features, {}) }), _jsx(ContactUs, { setPageSection: setPageSection })] }));
};
export default Landing;
